@import '~style-sheet-helpers/core';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/screen-width-breakpoints.module.less';
@import '../../constants/spacing.module.less';

.shipment-read-only {
  font-size: 16px;
  width: 100%;
}

.read-only-fields {
  padding: 0 0 @space-16;
}

.refund-fields {
  flex: 1;
  padding-top: @space-4;
}

.refund-row {
  padding-left: @space-16;
}

.refund-label {
  color: @read-only-shipment-display--label--text-color;
  width: 140px;
  display: inline-block;
}

.refund-info {
  align-items: center;
}

.refund-info-icon {
  height: 14px;
  width: auto;
  margin-left: @space-4;
}

.mdash {
  color: @read-only-shipment-display--mdash--text-color;
}
